<template>
  <div class="header-banner" :class="{ 'locale-zh-CN': isZhLocale }" :style="bannerStyle">
    <div class="banner-content">
      <div class="banner-title">
        <div class="title-main">
          <span v-if="titleMain1" class="title-main-1">{{ titleMain1 }}</span>
          <span v-if="titleMain2" class="title-main-2">{{ titleMain2 }}</span>
          <span v-if="!titleMain1 && !titleMain2" class="title-main-single">{{ title }}</span>
        </div>
        <div class="title-sub">{{ subtitle }}</div>
      </div>
      <div class="search-container" v-if="showSearch">
        <div class="search-box">
          <img :src="searchIconSafe" alt="" class="search-icon" @error="onImgError" />
          <div class="search-line"></div>
          <input 
            v-model="searchValue" 
            type="text" 
            :placeholder="effectivePlaceholder" 
            class="search-input"
            @keyup.enter="handleSearch"
          />
          <button class="search-button" @click="handleSearch">{{ effectiveButtonText }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { localeImg } from '@/utils/localeAsset'
import { getSafeImage, handleImgError } from '@/utils/imageFallback'
import { getText } from '@/utils/i18nText'
// import { reportSearchIfKeyword } from '@/utils/behaviorTrack'

export default {
  name: 'SearchBanner',
  props: {
    // 主标题 - 分段式(如: "供需"和"超市"两种颜色)
    titleMain1: {
      type: String,
      default: ''
    },
    titleMain2: {
      type: String,
      default: ''
    },
    // 主标题 - 单一式(如: "成果超市"一种颜色)
    title: {
      type: String,
      default: ''
    },
    // 副标题
    subtitle: {
      type: String,
      default: ''
    },
    // 搜索框占位符
    placeholder: {
      type: String,
      default: ''
    },
    // 按钮文字
    buttonText: {
      type: String,
      default: ''
    },
    // 搜索关键词(支持v-model)
    keyword: {
      type: String,
      default: ''
    },
    // 背景图片
    backgroundImage: {
      type: String,
      default: ''
    },
    // 搜索图标
    searchIcon: {
      type: [String, Object],
      default: null
    },
    // 是否显示搜索框（不显示时仍保留标题与banner背景）
    showSearch: {
      type: Boolean,
      default: true
    },
    searchObject: {
      type: String,
      default: ''
    },
    trackSearchOnSearch: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      searchValue: this.keyword
    }
  },
  computed: {
    bannerStyle() {
      if (this.backgroundImage) {
        return {
          backgroundImage: `url(${this.backgroundImage})`
        }
      }
      return {}
    },
    searchIconSrc() {
      if (this.searchIcon) {
        return this.searchIcon
      }
      return localeImg('gongxuzhongxin/search-ico.png')
    },
    searchIconSafe() {
      return getSafeImage(this.searchIconSrc)
    },
    effectivePlaceholder() {
      if (this.placeholder != null && String(this.placeholder).trim() !== '') {
        return this.placeholder
      }
      return getText('searchBanner.placeholderDefault', '请输入关键词检索')
    },
    effectiveButtonText() {
      if (this.buttonText != null && String(this.buttonText).trim() !== '') {
        return this.buttonText
      }
      return getText('searchBanner.searchButton', '搜索')
    }
  },
  watch: {
    keyword(val) {
      this.searchValue = val
    },
    searchValue(val, oldVal) {
      this.$emit('update:keyword', val)
      const wasNonEmpty = String(oldVal || '').trim()
      const nowEmpty = !String(val || '').trim()
      if (wasNonEmpty && nowEmpty) {
        this.$emit('search', val)
      }
    }
  },
  methods: {
    onImgError(event) {
      handleImgError(event)
    },
    handleSearch() {
      const kw = this.searchValue.trim()
      // 全局搜索行为上报（后台会返回 msg: ok，易触发查询提示，暂不展示）
      // if (this.trackSearchOnSearch && this.searchObject && kw) {
      //   reportSearchIfKeyword(kw, this.searchObject)
      // }
      this.$emit('search', this.searchValue)
    }
  }
}
</script>

<style lang="scss" scoped>
.header-banner {
  width: 1700px;
  height: 265px;
  margin: 16px 110px;
  background-image: url('~@/assets/img/gongxuzhongxin/head-bg.png');
  background-size: cover;
  background-position: center;
  display: flex;
  
  .banner-content {
    .banner-title {
      margin-top: 61px;
      margin-left: 79px;
      font-family: ZhenyanGB;
      font-weight: 400;
      
      .title-main {
        font-size: 38px;
        font-weight: 600;
        letter-spacing: 3px;
        
        .title-main-1 {
          color: #333333;
        }
        
        .title-main-2 {
          color: #8C7C26;
        }
        
        .title-main-single {
          color: #8C7C26;
        }
      }
      
      .title-sub {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 18px;
        margin-top: 12px;
        color: #A0903C;
        line-height: 26px;
      }
    }
    
    .search-container {
      .search-box {
        display: flex;
        align-items: center;
        width: 674px;
        height: 49px;
        margin-top: 21px;
        margin-left: 80px;
        background: rgba(255,255,255,0.4);
        border: 1px solid #FFFFFF;
        
        .search-icon {
          width: 18px;
          height: 18px;
          margin-left: 20px;
        }
        
        .search-line {
          width: 1px;
          height: 28px;
          margin-left: 16px;
          background: rgba(160,144,60,0.2);
        }
        
        .search-input {
          flex: 1;
          height: 100%;
          border: none;
          outline: none;
          font-size: 14px;
          color: #A0903C;
          background-color: transparent;
          margin-left: 20px;
          
          &::placeholder {
            color: rgba(160, 144, 60, 0.4);
          }
        }
        
        .search-button {
          width: 80px;
          height: 49px;
          background: rgba(140,124,38,0.4);
          border: none;
          font-family: Source Han Sans CN;
          font-weight: 500;
          font-size: 14px;
          color: #FFFFFF;
          line-height: 26px;
          text-shadow: 0px 0px 2px #827F5A;
          cursor: pointer;
          transition: all 0.3s;
          
          &:hover {
            background: rgba(140,124,38,0.6);
          }
          
          &:active {
            transform: translateY(0);
          }
        }
      }
    }
  }
}

.header-banner.locale-zh-CN {
  .banner-content .banner-title {
    .title-main {
      font-size: 50px;
    }

    .title-sub {
      font-size: 20px;
    }
  }

  .search-container .search-box .search-button {
    font-size: 20px;
  }
}
</style>
